import { makeStyles, Typography } from "@material-ui/core"
import React, { FC } from "react"
import { colors } from "../../utils/theme"
import HelpIcon from "../atoms/HelpIcon"
import { Tooltip } from "../atoms/tooltip/Tooltip"

const useStyles = makeStyles({
  tooltip: {
    width: 388,
    maxWidth: 388,
    minWidth: 388,
  },
  title: {
    color: colors.neutral.white,
    fontWeight: 700,
    marginBottom: 4,
  },
  text: {
    color: colors.neutral.white,
    fontWeight: 400,
  },
})

const AccountDeletedHelpIcon: FC<{ ended_at: string }> = ({ ended_at }) => {
  const classes = useStyles()
  return (
    <Tooltip
      title={
        <>
          <Typography variant="subtitle2" className={classes.title}>
            Account Deletion{" "}
            {ended_at && `on ${new Date(ended_at).toLocaleDateString()}`}
          </Typography>
          <Typography variant="body1" className={classes.text}>
            This client elected to delete their account{" "}
            {ended_at && `on ${new Date(ended_at).toLocaleDateString()}`}. The
            client will no longer be able to access the Vira app via their
            account. Data uploaded to the platform will remain available to you.
            All content scheduled by you will be ceased.
          </Typography>
        </>
      }
      className={classes.tooltip}
    >
      <HelpIcon />
    </Tooltip>
  )
}

export default AccountDeletedHelpIcon
